<template>
  <div>
    <vx-card class="mt-base mb-5">
      <heading size="h2" style-size="h4" class="mb-5">{{ activityTitle }}</heading>
      <p class="mb-5">
        In this task, you are going to attempt to stop and manage a bleeding "patient" (in this
        case, water spurting from a balloon).
      </p>

      <div class="vx-row mt-10 flex-row-reverse">
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base pl-10">
          <heading size="h3" style-size="h5" class="text-underline mb-5">Videos:</heading>
          <p class="mb-5">1. Demonstration of how to complete the balloon task.</p>
          <video-trigger
            button_id="baloon_video"
            :imageSrc="videoTriggerImg1"
            @click="showVideoPopup(popupVideo, 'baloon_video')"
            class="mb-5"
          ></video-trigger>
          <p class="mb-5">2. How to stop a bleed.</p>
          <video-trigger
            button_id="bleeding_video"
            :imageSrc="videoTriggerImg2"
            @click="
              showVideoPopup(
                'https://www.youtube.com/embed/Y1G8XQb0WBc?autoplay=1',
                'bleeding_video',
              )
            "
            class="mb-5"
          ></video-trigger>
          <p class="mb-5">3. How to stop a severe bleed.</p>
          <video-trigger
            button_id="bleeding_video_2"
            :imageSrc="videoTriggerImg3"
            @click="
              showVideoPopup(
                'https://www.youtube.com/embed/Z_Fkz7zLn-I?autoplay=1',
                'bleeding_video_2',
              )
            "
          ></video-trigger>
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base">
          <heading size="h3" style-size="h5" class="text-underline mb-5">You will need:</heading>
          <ul class="default-list">
            <li>A balloon</li>
            <li>2 pieces of gauze</li>
            <li>2 bandages</li>
            <li>Some tape</li>
            <li>A pair of gloves</li>
            <li>A pin</li>
            <li>A friend to video you completing the exercise (optional)</li>
          </ul>
          <heading size="h3" style-size="h5" class="text-underline mb-5">Your Task:</heading>
          <ul class="default-list">
            <li>
              Watch the demonstration video on the right to see what to do <br />(<span
                class="text-underline_italic"
                >Tip:</span
              >
              make sure you prick the balloon where the water is so that it doesn’t burst. It can
              also help to pinch the balloon between your fingers and prick it in the fold).
            </li>
            <li>
              Wash hands; put on gloves; apply gauze with pressure for up to 10 minutes; apply
              bandage. If the wound is still bleeding apply another gauze, apply pressure and
              bandage again. Do not remove the original bandage.
            </li>
            <li>Watch the 2 videos on how to stop bleeding.</li>
          </ul>

          <p class="mb-8 text-bold">
            Now answer the question below (and upload your video if you took one):
          </p>

          <label>
            What did you learn from the videos?
            <textarea-block v-model="data.question1" :editable="isEditable" />
          </label>

          <label>
            <p>Upload your photos or video:</p>
            <br />
            <fileupload-button-immediate
              v-model="uploaded_files['uploaded_file_1']"
              :is-editable="isEditable"
              filetype="media"
              index="1"
            />
          </label>

          <save-buttons :is-editable="isEditable" @save="save" />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      videoTriggerImg1: require('@/assets/images/experiences/nurse/balloon_task_full.jpg'),
      videoTriggerImg2: require('@/assets/images/experiences/nurse/stop_bleeding_full.jpg'),
      videoTriggerImg3: require('@/assets/images/experiences/nurse/stop_severe_bleeding_full.jpg'),
      uploaded_files: {
        uploaded_file_1: '',
      },
      popupVideo:
        $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL + '/content/nurse/stop_bleeding_900.mp4',
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
